// Teklifler listesi kullanım rehberi. Metinler 'guides' çeviri alanında.
import type { TFunction } from 'i18next';
import type { GuideContent } from '../../components/common/UsageGuideDialog';

const G = 'documents.offers';

export const offersGuide = (t: TFunction): GuideContent => ({
  layout: 'list',
  title: t(`${G}.title`, 'Teklifler nasıl kullanılır?'),
  intro: t(`${G}.intro`, 'Müşterilere verdiğiniz ve tedarikçilerden aldığınız teklifleri tek listede izlersiniz; teklifi görüntüleyip yazdırabilir, onaylanan teklifi siparişe veya faturaya dönüştürebilirsiniz. Haritada bir bölgeye tıklayarak o adıma geçebilirsiniz.'),
  regionLabels: {
    stats: t(`${G}.regions.stats`, 'Teklif kartları'),
    filters: t(`${G}.regions.filters`, 'Arama ve filtreler'),
    toolbar: t(`${G}.regions.toolbar`, 'Yeni teklif ve ⋮ menüsü'),
    table: t(`${G}.regions.table`, 'Teklif listesi'),
  },
  steps: [
    {
      region: 'stats',
      title: t(`${G}.s1.title`, '1. Teklif kartlarını okuyun'),
      text: t(`${G}.s1.text`, 'Üstteki kartlar listede görünen tekliflere göre hesaplanır; arama ve filtreleri değiştirince kartlar da değişir.'),
      tips: [
        t(`${G}.s1.tip1`, 'Açık Teklifler: Taslak ve Beklemede olan tekliflerin sayısı ve toplam tutarı.'),
        t(`${G}.s1.tip2`, 'Onaylandı - Bu Ay: bu ay oluşturulan, Onaylandı veya Faturalandırıldı durumundaki teklifler.'),
        t(`${G}.s1.tip3`, 'Reddedilen Teklifler: Reddedildi durumundaki tekliflerin sayısı.'),
        t(`${G}.s1.tip4`, 'Tekliften Satışa Dönüş Oranı: taslaklar hariç tekliflerin yüzde kaçının faturalandığı.'),
      ],
    },
    {
      region: 'filters',
      title: t(`${G}.s2.title`, '2. Teklifi bulun'),
      text: t(`${G}.s2.text`, '"Teklif Ara..." kutusuna yazın; Teklif Türü ile Verilen veya Alınan teklifleri seçin. "Filtreleri Göster" ile Durum filtresi ve tarih sıralaması (Yeniden Eskiye / Eskiden Yeniye) açılır.'),
      tips: [
        t(`${G}.s2.tip1`, 'Durumlar: Taslak, Beklemede, Onaylandı, Reddedildi, Faturalandırıldı, Siparişe Dönüştürüldü.'),
      ],
    },
    {
      region: 'toolbar',
      title: t(`${G}.s3.title`, '3. Yeni teklif oluşturun'),
      text: t(`${G}.s3.text`, '"Verilen Teklif" müşteriye vereceğiniz satış teklifinin, "Alınan Teklif" tedarikçiden gelen teklifin formunu açar. ⋮ menüsünde "Excel İndir" ve "Şablon Düzenle" bulunur.'),
      tips: [
        t(`${G}.s3.tip1`, 'Excel İndir: verilen teklifler, alınan teklifler ve teklif kalemleri ayrı sayfalarda iner.'),
        t(`${G}.s3.tip2`, 'Şablon Düzenle: teklif çıktısının (PDF / baskı) görünümünü tasarladığınız ekranı açar.'),
      ],
    },
    {
      region: 'table',
      title: t(`${G}.s4.title`, '4. Görüntüleyin, yazdırın, düzenleyin'),
      text: t(`${G}.s4.text`, 'Satırın sonundaki ⋮ düğmesi teklif işlemlerini açar. "Görüntüle" teklifi şablonla gösterir; açılan pencereden yazdırabilir veya PDF indirebilirsiniz. "Düzenle" teklif formunu açar, "PDF İndir" doğrudan PDF verir.'),
      tips: [
        t(`${G}.s4.tip1`, 'Görüntülemede önce varsayılan şablon (⭐) kullanılır; pencerenin üstünden başka bir şablon seçebilirsiniz.'),
        t(`${G}.s4.tip2`, '"Sil" teklifi onay sorduktan sonra siler; bu işlem geri alınamaz.'),
      ],
    },
    {
      region: 'table',
      title: t(`${G}.s5.title`, '5. Siparişe veya faturaya dönüştürün'),
      text: t(`${G}.s5.text`, 'Onaylandı, Faturalandırıldı veya Siparişe Dönüştürüldü durumundaki tekliflerde ⋮ menüsünde "Sipariş Oluştur" ve "Fatura Oluştur" görünür. Bu düğmeler teklifin carisini, kalemlerini ve fiyatlarını yeni sipariş / fatura formuna doldurur; belge ancak siz o formu kaydedince oluşur.'),
      tips: [
        t(`${G}.s5.tip1`, 'Verilen teklif satış siparişine / satış faturasına, alınan teklif alış siparişine / alış faturasına aktarılır.'),
        t(`${G}.s5.tip2`, 'Teklif zaten bir faturaya veya siparişe bağlıysa menüde "Fatura Göster" / "Sipariş Göster" çıkar; durum etiketine tıklayarak da bağlı belgeyi açabilirsiniz.'),
        t(`${G}.s5.tip3`, 'Taslak, Beklemede veya Reddedildi durumundaki tekliflerde bu seçenekler görünmez.'),
      ],
    },
    {
      region: 'pagination',
      title: t(`${G}.s6.title`, '6. Sayfalar arasında gezin'),
      text: t(`${G}.s6.text`, 'Liste uzunsa alttaki sayfalama ile ilerleyin ve sayfa başına kaç satır görüneceğini seçin. Başlıktaki (i) düğmesi bu rehberi her zaman yeniden açar.'),
    },
  ],
});
